import { ApiClient } from '../../api-client/api-client';
import {
  IA3,
  PartialProjectCloseoutSchema,
  PartialProjectRequestSchema,
  ProjectLifecycleNotificationEmailRequest,
  ProjectProgressReportData,
  ProjectQualityControlFormData,
  UploadProjectCloseoutChecklistRequest,
} from '../../api-client/autogenerated';

export const upsertProjectRequestForm = async (
  projectId: string,
  body: PartialProjectRequestSchema,
) => {
  return ApiClient.upsertProjectRequestForm({ projectId, body }).then((res) => res.data);
};

export const upsertProjectCloseoutForm = async (
  projectId: string,
  body: PartialProjectCloseoutSchema,
) => {
  return ApiClient.upsertProjectCloseoutForm({ projectId, body }).then((res) => res.data);
};

export const uploadProjectCloseoutChecklist = async (
  projectId: string,
  params: UploadProjectCloseoutChecklistRequest,
) => {
  return ApiClient.uploadProjectCloseoutChecklist({
    projectId,
    uploadProjectCloseoutChecklistRequest: params,
  });
};

export const insertProjectProgressReportForm = async (
  projectId: string,
  body: ProjectProgressReportData,
) => {
  return ApiClient.insertProjectProgressReportForm({
    projectId,
    projectProgressReportData: body,
  }).then((res) => res.data);
};

export const editProjectProgressReportFormById = async (
  projectId: string,
  reportId: string,
  body: ProjectProgressReportData,
) => {
  return ApiClient.editProjectProgressReportFormById({
    projectId,
    reportId,
    projectProgressReportData: body,
  }).then((res) => res.data);
};

export const insertProjectQualityControlForm = async (
  projectId: string,
  body: ProjectQualityControlFormData,
) => {
  return ApiClient.insertProjectQualityControlForm({
    projectId,
    projectQualityControlFormData: body,
  }).then((res) => res.data);
};

export const editProjectQualityControlFormById = async (
  projectId: string,
  formId: string,
  body: ProjectQualityControlFormData,
) => {
  return ApiClient.editProjectQualityControlFormById({
    projectId,
    formId,
    projectQualityControlFormData: body,
  }).then((res) => res.data);
};

export const deleteProjectQualityControlFormById = async (projectId: string, formId: string) => {
  return ApiClient.deleteProjectQualityControlFormById({ projectId, formId }).then(
    (res) => res.data,
  );
};

export const deleteProjectRequestForm = async (projectId: string) => {
  return ApiClient.deleteProjectRequestForm({ projectId }).then((res) => res.data);
};

export const deleteA3 = async (projectId: string) => {
  return ApiClient.deleteA3({ projectId }).then((res) => res.data);
};

export const deleteProjectCloseoutForm = async (projectId: string) => {
  return ApiClient.deleteProjectCloseoutForm({ projectId }).then((res) => res.data);
};

export const deleteProjectProgressReportFormById = async (projectId: string, reportId: string) => {
  return ApiClient.deleteProjectProgressReportFormById({ projectId, reportId }).then(
    (res) => res.data,
  );
};

export const sendProjectLifecycleNotificationGroupEmails = async (
  projectId: string,
  body: ProjectLifecycleNotificationEmailRequest,
) => {
  return ApiClient.sendProjectLifecycleNotificationGroupEmails({
    projectId,
    projectLifecycleNotificationEmailRequest: body,
  }).then((res) => res.data);
};

export const upsertA3 = async (projectId: string, body: any) => {
  return ApiClient.upsertA3({ projectId, body }).then((res) => res.data);
};

export const getA3 = async (projectId: string): Promise<IA3> => {
  return ApiClient.getA3Data({ projectId }).then((res) => res.data);
};
